<template>
    <a-modal :visible="isShow" :width="1000" @cancel="cancel" :footer="null" :maskClosable="false" destroyOnClose :closable="false">
        <template #title>
            <a-row class="title_wrapper">
                <img src="~@/assets/images/basic/pay_logo.png" width="96" height="31" />
                <a-divider type="vertical" lass="divider" />
                <img src="~@/assets/images/basic/pay_syt.png" width="58" height="19" />
            </a-row>
        </template>
        <div>
        <a-row type="flex" justify="space-between" align="middle">
            <a-col>
                <img v-if="payDesc != ''" src="~@/assets/images/basic/pay_select.png" width="18" height="18" />
                <span class="ml10" v-if="payDesc != ''">{{payDesc}}</span>
                <span class="com_price" v-if="comPrice != 0">{{ comPrice }}</span>
            </a-col>
            <!-- <a-col>应付金额：<span class="price">{{price}}</span>元</a-col> -->
        </a-row>
        <div v-if="curStep === 'select'" class="pay_method_wrapper">
            <a-row>请选择支付方式</a-row>
            <div class="select_wrapper">
                <a-row v-for="method in payMethods" :key="method.value" :class="['item_method',{'active':payType === method.value}]" @click.native="changePayMethod(method.value)" type="flex" justify="space-between" align="middle" v-if="isShowPayType(method.value)">
                    <a-col>
                        <a-checkbox :checked="payType === method.value">
                            <img :src="method.icon" width="33" height="33" />
                            <span>{{method.label}}</span>
                            <span v-if="method.value == 'prepay'" class="balance">￥{{ balance }}</span>
                            <span v-else-if="payType === method.value" class="pay_des">{{method.des}}</span>
                        </a-checkbox>
                    </a-col>
                    <a-col v-show="payType === method.value" class="price_col">
                        <p>支付<span class="price">{{Number(totalPrice).toFixed(2)}}</span>元</p>
                        <p v-if="method.value != 'prepay'" class="poundage_des">
                            {{typeName}}金额<span> ¥{{Number(payPrice).toFixed(2)}}</span>，支付手续费<span> ¥{{poundage}}</span>
                            <span class="poundage_des" v-if="balance < 0">，补余额欠款<span> ¥{{balance}}</span></span>
                        </p>
                    </a-col>
                </a-row>
            </div>
            <a-row type="flex" justify="end" :gutter="20" class="btn_wrapper">
                <a-col>
                    <a-button class="pay_cancel pay_btn_size" @click="cancel">取消支付</a-button>
                </a-col>
                <a-col>
                    <a-button type="primary" @click="next" class="pay_confirm pay_btn_size">确认支付</a-button>
                </a-col>
            </a-row>
        </div>
        <div v-else class="basic_wrapper mt20">
            <div v-if="curStep === 'prepay'" class="basic_wrapper mt20">
                <a-row>余额支付</a-row>
                <div class="pay_password_wrapper">
                    <a-row type="flex" justify="center" align="middle">
                        <a-col class="label">支付密码：</a-col>
                        <a-col class="input">
                            <a-input-password v-model="payPassword" placeholder="请输入支付密码" :visibilityToggle="false" />
                        </a-col>
                    </a-row>
                    <a-row type="flex" justify="center">
                        <transition name="slide-fade">
                            <router-link v-if="validPayPassword" :to="{path: '/paypsd',query: { redirect: $route.path}}" class="error text_red pointer" custom v-slot="{navigate}">
                            <p @click="navigate">请输入支付密码，如忘记支付密码，请点击此处修改</p>
                            </router-link>
                        </transition>
                    </a-row>
                </div>
            </div>
            <div v-else-if="curStep === 'wxpay'">
                <a-row>微信支付</a-row>
                <a-row type="flex" justify="space-around" class="mt20">
                    <a-col>
                        <div class="wx_qrcode_wrapper img_wrapper">
                            <img :src="wxQrcode" />
                        </div>
                        <img class="img_scan" src="~@/assets/images/basic/pay_scan_code.png" alt="扫描二维码支付" />
                    </a-col>
                    <a-col>
                        <img class="img_wxpay_info" src="~@/assets/images/basic/pay_wxpay_info.png" alt="微信二维码支付" />
                    </a-col>
                </a-row>
            </div>
            <div v-else-if="curStep === 'unionChinaums'">
              <a-row>
                <a-col :span="16">
                  <p class="pay_title">银联支付</p>
                  <p class="pay_tips">(请使用微信、支付宝或云闪付APP扫码付款)</p>
                </a-col>
                <a-col :span="8">
                  <div class="img_union_container box_center">
                    <div class="img_union_box img_wrapper">
                      <img v-if="unionChinaumsCode" :src="unionChinaumsCode"/>
                      <div v-else class="box_center" style="width: 100%;height: 100%">
                        <a-spin />
                      </div>
                    </div>
                  </div>
                </a-col>

              </a-row>
            </div>
            <a-row type="flex" justify="space-between" class="btn_wrapper">
                <a-col class="text_blue pointer" @click.native="back">
                    <a-icon type="left" />选择其他支付方式
                </a-col>
                <a-col>
                    <a-space :size="20">
                        <a-button class="pay_cancel pay_btn_size" @click="cancel">取消支付</a-button>
                        <a-button type="primary" @click="prepay" v-if="curStep === 'prepay'" :loading="loading" class="pay_confirm pay_btn_size">确认支付</a-button>
                    </a-space>
                </a-col>
            </a-row>
        </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: 'PayModal',
    model: {
        prop: 'isShow',
        event: 'show',
    },
    props: {
        isShow: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        id: {
            type: String | Number,
            default: ''
        },
        price: {
            type: Number | String,
            required: true
        },
        sn: { // 充值单号
            type: String,
            default: ''
        },
        isShowPreMethod: {
            type: Boolean,
            default: true
        },
        returnUrl: { //前端路由
            type: String,
            required: true
        },
        isAutoJump: {
            type: Boolean,
            default: true
        },
        source: {
          type: String,
          default: '用户中心'
        }
    },
    data () {
        return {
            payPassword: '',
            validPayPassword: false,
            isBindPayPassword: false,
            curStep: 'select',
            payType: 'alipay',
            payMethods: [
                {
                    label: '支付宝',
                    value: 'alipay',
                    icon: require('@/assets/images/basic/pay_alipay.png'),
                    des: '(银行手续费费率0.3%)'
                },
                {
                    label: '微信',
                    value: 'wxpay',
                    icon: require('@/assets/images/basic/pay_wxpay.png'),
                    des: '(银行手续费费率0.3%)'
                },
            ],
            preMethod: {
                label: '余额',
                value: 'prepay',
                icon: require('@/assets/images/basic/pay_prepay.png')
            },
            wxQrcode: '',
            tid:'',
            poundage: 0,
            totalPrice: 0,
            typeName: '',
            payPrice: 0,
            balance: 0,
            payDesc: '',
            comPrice: 0,
            comPoundage: 0,
            uid: 0,
            loading: false,
            unionChinaumsCode:'',
            payTypeToGrayId: {
              'unionChinaums':5
            },
            grayDetail: {}
        }
    },
    created () {
        this.getGrayStatus()
        this.getAccountSafeInfo()
        this.getTypeName()
        this.getPayType()
    },
    methods: {
        getGrayStatus() {
          let _this = this
          _this.$util.api('/gray/details',{id:Object.values(this.payTypeToGrayId)},res => {
            if(res.code === 10000 && res.data.length>0){
              res.data.forEach(item => {
                if (item.uids.length > 0) {
                  item.uids.forEach((id,index) => {
                    item.uids[index] = Number(id)
                  })
                }
                _this.grayDetail[item.id] = item
              })
            }
          });
        },
        isShowPayType(pay_type) {
          let grayId = this.payTypeToGrayId[pay_type]
          if (grayId === undefined || !grayId) {
            return true
          }
          let grayInfo = this.grayDetail[grayId]
          if (grayInfo === undefined || !grayInfo) {
            return true
          }
          //全开
          if (grayInfo.status === 3) {
            return true
          }
          //灰度
          if (grayInfo.status === 2 && grayInfo.uids.includes(this.uid)) {
            return true
          }
          //不开放
          if (grayInfo.status === 1) {
            return false
          }

          return false
        },
        getPayType(){
            this.$util.api('/pay/type',{},res => {
                if(res.code == 10000){
                    var list = [];
                    var index = '';

                    for(var i = 0; i < res.data.length; i++){
                        list.push({
                            label: res.data[i].name,
                            value: res.data[i].code,
                            icon: res.data[i].icon,
                            des: res.data[i].des
                        });

                        if(res.data[i].is_default == 1){
                            index = res.data[i].code;
                        }
                    }
                    //京东暂停使用微信支付和天满银联
                    if (this.source === 'jd_supply') {
                      list.forEach((item,index) => {
                        if (item.value === 'wxpay') {
                          list.splice(index,1)
                        }
                      })
                    }

                    this.payMethods = list;
                    this.payType = index;

                    if (this.isShowPreMethod) {
                        this.payMethods.push(this.preMethod)
                    }
                }
            });
        },
        getTypeName(){
            var res = '';

            switch(this.type){
                case 'order':
                    res = '订单';
                    break;
                case 'diffprice':
                    res = '补差价';
                    break;
            }

            this.typeName = res;
        },
        getTotalPrice(){
            if(this.payType == 'prepay'){
                this.poundage = 0;
                this.totalPrice = this.payPrice;
            }else{
                this.$util.api('/pay/poundage',{
                    price: this.payPrice
                },res => {
                    if(res.code == 10000){
                        this.$util.api('/finance/info',{},result => {
                            if(result.code == 10000){
                                this.balance = result.data.balance;

                                let price = parseFloat(this.payPrice) + parseFloat(res.data);

                                if(this.balance < 0){
                                    price -= parseFloat(this.balance);
                                }

                                this.poundage = Number(res.data).toFixed(2);
                                this.totalPrice = Number(price).toFixed(2);
                            }
                        });
                    }
                });
            }
        },
        getAccountSafeInfo () {
            this.$util.api('/login/status',{},res => {
                if(res.code == 10000){
                    this.isBindPayPassword = res.data.is_pay_password == 1 ? true : false;
                    this.uid = res.data.id
                }
            });
        },
        cancel () {
            this.comPrice = 0;
            this.comPoundage = 0;
            this.payDesc = this.desc;
            this.curStep = 'select';
            this.$emit('show', false)
        },
        changePayMethod (method) {
            this.payType = method;
            this.getTotalPrice();
        },
        next () {
            const { payType, isBindPayPassword, sn, returnUrl } = this
            this.curStep = payType
            var _this = this;

            switch (payType) {
                case 'prepay':
                    if (!isBindPayPassword) {
                        var text_ok = '确认';
                        if(_this.source === 'jd_supply'){
                            text_ok = '去设置';
                        }
                        this.$info({
                            title: '您还没有设置支付密码，点击确认前往设置',
                            okText: text_ok,
                            onOk: () => {
                                if(_this.source === 'jd_supply'){
                                    //京东走单独支付密码设置页面
                                    window.open('/jd/paypsd','_blank');
                                    return false;
                                }

                                this.$router.push({
                                    path: '/paypsd',
                                    query: {
                                        redirect: this.$route.path
                                    }
                                })
                            }
                        })
                        return
                    }

                    break
                case 'wxpay':
                    _this.$util.api('/pay/wxpay',{
                        type: _this.type,
                        ids: _this.id,
                        recharge: this.balance < 0 ? this.balance : 0
                    },function(res){
                        if(res.code == 10000){
                            _this.wxQrcode = res.data.qrcode;
                            _this.checkPayStatus(res.data.id);
                        }else{
                            _this.$message.error(res.msg);
                        }
                    });

                    break
                case 'alipay':
                    _this.$util.api('/pay/alipay',{
                        type: _this.type,
                        ids: _this.id,
                        recharge: this.balance < 0 ? this.balance : 0
                    },function(res){
                        if(res.code == 10000){
                            window.location.href = res.data.url;
                        }
                    });

                    break
                case 'unionpay':
                    var return_url = returnUrl;

                    if(returnUrl.indexOf('https://') == -1 && returnUrl.indexOf('http://') == -1){
                        return_url = 'https://member.91jf.com' + returnUrl;
                    }

                    _this.$util.api('/pay/unionpay',{
                        type: _this.type,
                        ids: _this.id,
                        return_url: return_url
                    },res => {
                        _this.curStep = 'select';

                        if(res.code == 10000){
                            window.location.href = res.data.url;
                        }else{
                            _this.$message.error(res.msg);
                        }
                    });
                    break
                case 'unionChinaums':
                    _this.$util.api('/pay/unionChinaums',{
                      type: _this.type,
                      ids: _this.id,
                    },function(res){
                      if(res.code == 10000){
                        _this.unionChinaumsCode = res.data.qrcode
                        _this.checkPayStatus(res.data.id);
                      }else{
                        _this.$message.error(res.msg);
                      }
                    });
                    break
                default: break
            }
        },
        prepay () {
            const { payPassword } = this
            if (this.$util.isEmpty(payPassword)) {
                this.validPayPassword = true
                return
            }
            // console.log(this.totalPrice,this.balance);
            var balance = parseFloat(this.balance);
            var total = parseFloat(this.totalPrice);

            this.loading = true;
            this.$util.api('/pay/prepay',{
                type: this.type,
                ids: this.id,
                password: payPassword
            },res => {
                if(res.code == 10000){
                  this.payPassword = ''
                    this.handleSuccess();
                }else{
                    this.loading = false;
                    this.$message.error(res.msg)
                }
            });
        },
        handleSuccess () {
            clearInterval(this.tid);
            this.$message.success('支付成功');
            this.loading = false;
            this.$emit('show', false);
            this.$emit('success');

            if (this.isAutoJump) {
                if(this.returnUrl.indexOf('https://') == -1 && this.returnUrl.indexOf('http://') == -1){
                    this.$router.replace(this.returnUrl)
                }else{
                    window.location.href = this.returnUrl;
                }
            }
        },
        back () {
            clearInterval(this.tid);
            this.curStep = 'select';
            this.payDesc = this.desc;
            this.comPrice = 0;
            this.comPoundage = 0;
        },
        checkPayStatus (id) {
            if(!id || id == ''){
                return false;
            }
            var _this = this;
            _this.tid = setInterval(function(){
                _this.$util.api('/pay/status',{
                    id: id
                },function(res){
                    if(res.code == 10000 && res.data == 1){
                        _this.handleSuccess();
                    }
                });

            },2000)
        },
        getBalance(){
            this.$util.api('/finance/info',{},res => {
                if(res.code == 10000){
                    this.balance = res.data.balance;
                }
            });
        }
    },
    watch: {
        payPassword (val) {
            if (val) this.validPayPassword = false
        },
        price: {
            handler(val){
                this.payPrice = val;
                this.getTotalPrice();
                this.getBalance();
            },
            deep: true,
            immediate: true
        },
        desc: {
            handler(val){
                this.payDesc = val;
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>
.com_price{
    font-size:32px;
    color:#333;
}
.balance{
    font-size:13px;
    color:#fd5902;
    font-weight: 400;
    margin-left:10px;
}
.price_col{
    text-align:right;
}
.poundage_des{
    color:#999 !important;
    font-size:12px;
}
.poundage_des span{
    color:#333;
}
.pay_des{
    color:#999;
    font-size:12px;
    margin-left:5px;
}
.divider {
    width: 2px;
    height: 30px;
    margin: 0 15px;
}

::v-deep .ant-modal-body {
    padding: 24px 120px;
    background: #f7f7f7;
}
::v-deep .ant-modal {
    width: 1000px !important;
}

.price {
    color: rgba(253, 89, 2, 1);
    font-size: 24px;
    font-family: MicrosoftYaHei-Bold;
}

.pay_method_wrapper {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
}

.pay_method_wrapper .select_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
}

.select_wrapper .active {
    background: #fff;
    box-shadow: 0 0 10px #595959;
}

.ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
}

.item_method {
    height: 66px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f7f7f7;
    padding: 0 20px;
    cursor: pointer;
}

.item_method img {
    margin-left: 30px;
    margin-right: 10px;
}

.item_method:nth-child(n + 2) {
    margin-top: 10px;
}

.item_method .price {
    font-size: 18px;
    color: #fd5902;
    padding: 0 5px;
}

.btn_wrapper {
    margin-top: 40px;
}

.pay_password_wrapper {
    padding: 40px 0;
}
.pay_password_wrapper .label {
    font-size: 16px;
    font-weight: bold;
}
.pay_password_wrapper .input {
    width: 350px;
}
.pay_password_wrapper .error {
    margin-top: 5px;
    width: 350px;
    margin-left: 80px;
}

.img_wxpay_info {
    width: 253px;
    height: 300px;
}
.img_scan {
    margin-top: 10px;
    width: 223px;
    height: 47px;
}
.wx_qrcode_wrapper {
    width: 222px;
    height: 222px;
    border: 1px solid rgba(191, 191, 191, 1);
}
.img_union_container {
  width: 247px;
  height: 312px;
  background: url("~@/assets/images/basic/phone_bg.png") no-repeat;
  background-size: cover;
}
.img_union_box {
  width: 115px;
  height: 115px;
}
.pay_title {
  font-family: "PingFang SC";
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  color: #333333;
}
.pay_tips {
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #666666;
}
.pay_confirm {
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 500;
}
.pay_cancel {
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.pay_btn_size {
  width: 80px;
  height: 40px;
  border-radius: 4px;
  background: #e7e7e7;
}
.box_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PayModal.vue